// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b96f2fec","896":"c6c03918","921":"28ee69c4","950":"791928f0","958":"721eac56"}[chunkId] + ".chunk.js";
};